import {FC} from 'react'

import cn from 'classnames/bind'

import LandingsAccordion from 'components/blocks/LandingsAccordion'
import {Col, Container, Row} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'

import s from './Make1099Differences.module.scss'
const cx = cn.bind(s)

interface IMake1099DifferencesProps {
	className?: string
	content: IMake1099Content['differences']
}

/** Make1099Differences block component */
const Make1099Differences: FC<IMake1099DifferencesProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col>
						<LandingsAccordion items={content?.items} />
					</Col>
				</Row>
			</Container>
		</div>
	)
}

Make1099Differences.displayName = 'Make1099Differences'

export default Make1099Differences
